<template>
  <div>
    <back-button default-to="/sales"/>
    <b-card no-header>
      <div class="d-flex mb-2">
        <div>
          <b-badge :variant="statusVariant(approvalStatus)">{{ statusLabel(approvalStatus) }}</b-badge>
        </div>
        <b-button-group class="add-button-group ml-auto">
          <b-btn v-if="isApproved" variant="primary" :href="`${apiUrl.sale}/${$route.params.id}?print_pdf=1&access_token=${$store.getters['account/accessToken']}`" target="_blank" type="button" ><font-awesome-icon icon="file-pdf"/> Cetak Invoice</b-btn>
        </b-button-group>
      </div>
      <b-alert :show="!isApproved" variant="warning">
        Penjualan ini belum final, sehingga belum mengurangi stok, belum masuk laporan, dan invoicenya belum dapat dicetak.
      </b-alert>
      <b-alert :show="approvalStatus === 'returned' && !!reviewNote" variant="warning">
        Dikembalikan untuk diperbaiki: {{ reviewNote }}
      </b-alert>
      <b-alert :show="approvalStatus === 'rejected'" variant="danger">
        Ditolak{{ reviewNote ? ': ' + reviewNote : '.' }} Penjualan dapat diperbaiki dan diajukan ulang oleh pembuatnya.
      </b-alert>
      <p v-if="reviewInfo.submitted_at" class="text-muted small">Diajukan oleh {{ actorName(reviewInfo.submitter) }} pada {{ formatDateTime(reviewInfo.submitted_at) }}.</p>
      <p v-if="reviewInfo.edited_at" class="text-muted small">Terakhir diubah oleh {{ actorName(reviewInfo.editor) }} pada {{ formatDateTime(reviewInfo.edited_at) }}.</p>
      <b-row>
        <b-col cols="12" md="6" class="mb-1">
          <div>
            <div>
              <label for="nama" class="form-label mb-2">
                Pelanggan
              </label>
            </div>
            <span v-if="costumer" style="cursor: pointer;" @click.prevent="$refs.costumerDetailModal.openModal(costumer.id)">
              <div class="d-flex flex-wrap" style="cursor: pointer;">
                <div class="mb-2 mr-2" style="cursor: pointer;"><strong>Nama</strong>: {{ costumer.nama}}</div><div class="mb-2 mr-2">, <strong>No. HP</strong>: {{ costumer.no_hp }}</div><div class="mb-2" v-if="costumer.nik">, <strong>NIK</strong>: {{ costumer.nik }}</div>
              </div>
            </span>
          </div>
        </b-col>
        <div class="col-md-6 col-12"><div><div class="mb-3"><label class="form-label w-100" style="font-size: 80%;">No. Invoice</label><p class="heading-color">{{ transaction_no }}</p></div></div></div>
        <b-col cols="12" md="6" v-for="(m, index) in filterSaleModel(['tanggal_transaksi'])"  :key="'sale_model_1_ ' + index">
          <div>
            <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" :skipPriceTag="index === 'berat'" />
          </div>
        </b-col>
        <!-- <b-col cols="12" md="6">
          <div><div class="mb-3"><label class="form-label w-100" style="font-size: 80%;">Status</label><p class="heading-color">
            <b-badge variant="success" class="p-2" v-if="model.status_bayar.value === 'lunas'">Lunas</b-badge>
            <b-badge variant="secondary" class="p-2" v-else>Belum Lunas</b-badge>
          </p></div></div>
        </b-col> -->
        <b-col cols="12" md="6" v-for="(m, index) in filterSaleModel(['metode_pembayaran'])"  :key="'sale_model_2_ ' + index">
          <div>
            <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" :skipPriceTag="index === 'berat'" />
          </div>
        </b-col>
      </b-row>
      <div class="mt-2 mb-3">
        <form-detail ref="formDetail" :model="detailModel" mode="detail" :rows="details" colTotlalName="harga_jual" />
      </div>
      <!-- <div class="mt-2 mb-3">
        <b-row>
          <b-col cols="12" md="2" v-for="(m, index) in filterSaleModel(['metode_pembayaran'])"  :key="'sale_model_2_ ' + index">
            <div>
              <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" :skipPriceTag="index === 'berat'" />
            </div>
          </b-col>
        </b-row>
      </div> -->
      <div class="mt-2 mb-3">
        <b-row>
          <b-col cols="12" md="12" v-for="(m, index) in filterSaleModel(['catatan'])"  :key="'sale_model_3_ ' + index">
            <div>
              <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" :skipPriceTag="index === 'berat'" />
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="isAdmin && approvalStatus === 'on_review'" class="mb-3">
        <b-button variant="success" :disabled="isLoading" @click="approve">Setujui</b-button>
        <b-button variant="warning" class="ml-2" :disabled="isLoading" @click="showDecline('return')">Kembalikan</b-button>
        <b-button variant="danger" class="ml-2" :disabled="isLoading" @click="showDecline('reject')">Tolak</b-button>
      </div>
      <div v-if="isApproved" class="mb-3">
        <approval-request-actions
          target-type="sale"
          :target-id="$route.params.id"
          :created-by="createdBy"
          :reopenable="true"
          @submitted="getDetail" />
      </div>
      <div>
        <b-button v-if="canEdit" :to="'/sales/' + $route.params.id + '/edit'" variant="primary" class="mt-0">Ubah</b-button>
        <b-button v-if="canEdit" variant="primary" class="mt-0 ml-2" :disabled="isLoading" @click="submit">Ajukan Persetujuan</b-button>
        <b-button v-if="canEdit" variant="danger" class="mt-0 ml-2" :disabled="isLoading" @click="removeDraft">Hapus Draft</b-button>
        <b-button :to="'/sales/'" variant="secondary" class="ml-3 float-right">Kembali</b-button>
      </div>
    </b-card>
    <b-modal ref="declineModal" :title="declineMode === 'return' ? 'Kembalikan untuk Diperbaiki' : 'Tolak Penjualan'" :ok-title="declineMode === 'return' ? 'Kembalikan' : 'Tolak'" cancel-title="Batal" @ok="decline">
      <form-group-input type="textarea" label="Catatan Alasan" :need-label="true" v-model="declineNote" id="review_note" />
    </b-modal>
    <costumer-detail-modal ref="costumerDetailModal" title="Detail Data Pelanggan"/>
  </div>
</template>

<script>
import { setModelValue, Roles } from '@/_helpers'
import detailGroupInput from '@/components/DetailGroupInput.vue'
import costumerDetailModal from '@/pages/Costumer/DetailModal.vue'
import Sale from '@/models/Sale.js'
import formDetail from '@/components/FormDetail';
import formGroupInput from '@/components/FormGroupInput.vue'
import approvalRequestActions from '@/components/ApprovalRequestActions.vue'
import SaleDetail from '@/models/SaleDetail.js'

const saleModel = new Sale()
const saleDetailModel = new SaleDetail()

export default {
  components: {
    detailGroupInput,
    costumerDetailModal,
    formDetail,
    formGroupInput,
    approvalRequestActions
  },
  computed: {
    isAdmin () {
      return this.$store.getters['account/accountData'].role === Roles.ADMIN
    },
    isApproved () {
      return this.approvalStatus === 'approved'
    },
    canEdit () {
      return Number(this.createdBy) === Number(this.$store.getters['account/accountData'].id) &&
        ['draft', 'returned', 'rejected'].indexOf(this.approvalStatus) !== -1
    }
  },
  watch: {
    '$route.params.id': function (val) {
      if (val !== undefined) {
        this.getDetail()
      }
    }
  },
  data () {
    return {
      Roles: Roles,
      isLoading: false,
      transaction_no: null,
      approvalStatus: null,
      reviewNote: null,
      createdBy: null,
      reviewInfo: {},
      declineMode: 'return',
      declineNote: '',
      costumer: null,
      details: [],
      model: saleModel.init(),
      detailModel: saleDetailModel.init(),
      apiUrl: {
        sale: saleModel.endpoint
      },
    }
  },
  mounted () {
    this.detailModel.stock_barcode.type = 'text';
    this.getDetail()
  },
  methods: {
    filterSaleModel (search, type = 'include') {
      const filtered = Object.entries(this.model).filter(mdl => {
        return type === 'include' ? search.includes(mdl[0]) : !search.includes(mdl[0])
      });
      let result = {}
      filtered.forEach(element => {
        result[element[0]] = element[1];
      });
      return result;
    },
    filterModel (search) {
      const filtered = Object.entries(this.model).filter(mdl => {
        return search.includes(mdl[0])
      });
      let result = {}
      filtered.forEach(element => {
        result[element[0]] = element[1];
      });
      return result;
    },
    statusLabel (status) {
      return { draft: 'Draft', on_review: 'On Review', approved: 'Disetujui', returned: 'Dikembalikan', rejected: 'Ditolak' }[status] || status
    },
    statusVariant (status) {
      return { draft: 'secondary', on_review: 'warning', approved: 'success', returned: 'warning', rejected: 'danger' }[status] || 'secondary'
    },
    async runAction (action, successMessage) {
      this.isLoading = true
      try {
        await action()
        this.$store.dispatch('notification/success', successMessage)
        await this.getDetail()
      } catch (e) {
        this.$store.dispatch('notification/error', e)
      }
      this.isLoading = false
    },
    submit () {
      return this.runAction(() => saleModel.submit(this.$route.params.id), 'Penjualan berhasil diajukan.')
    },
    approve () {
      return this.runAction(() => saleModel.approve(this.$route.params.id), 'Penjualan disetujui, stok telah diperbarui.')
    },
    showDecline (mode) {
      this.declineMode = mode
      this.declineNote = ''
      this.$refs.declineModal.show()
    },
    decline () {
      const note = this.declineNote
      const mode = this.declineMode
      return this.runAction(
        () => mode === 'return' ? saleModel.returnForRevision(this.$route.params.id, note) : saleModel.reject(this.$route.params.id, note),
        mode === 'return' ? 'Penjualan dikembalikan untuk diperbaiki.' : 'Penjualan ditolak.'
      )
    },
    actorName (actor) { return actor && actor.name ? actor.name : '-' },
    formatDateTime (value) { return value ? this.$moment(value).format('DD/MM/YYYY HH:mm') : '-' },
    async removeDraft () {
      if (!window.confirm('Hapus draft penjualan ini?')) return
      this.isLoading = true
      try {
        await saleModel.delete(this.$route.params.id)
        this.$store.dispatch('notification/success', 'Draft penjualan dihapus.')
        this.$router.push('/sales')
      } catch (e) {
        this.$store.dispatch('notification/error', e)
      }
      this.isLoading = false
    },
    async getDetail () {
      this.isLoading = true
      try {
        const resp = await saleModel.find(this.$route.params.id);
        this.costumer = resp.costumer;
        this.details = resp.detail_barang;
        this.transaction_no = resp.transaction_no;
        this.approvalStatus = resp.approval_status;
        this.reviewNote = resp.review_note;
        this.createdBy = resp.created_by;
        this.reviewInfo = resp;
        setModelValue(this.model, resp);
      }
      catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(e)
        }
      }

      this.isLoading = false
    }
  }
}
</script>
